import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import Header from 'src/components/Header';
import CustomersBar from 'src/components/CustomersBar';
import AdminRolesAndPermissions from 'src/components/AdminRolesAndPermissions';
import AdminUsers from 'src/components/AdminUsers';
import AccountStaffChangePasswordForm from 'src/components/AccountStaffPasswordManageForms/AccountStaffChangePasswordForm';
import { AdminCountryDefaultsNew } from 'src/components/AdminCountryDefaults/AdminCountryDefaults';
import Ladders from 'src/components/Ladders';
// import RelatedContingency from 'src/components/RelatedContingency';
import Audits from 'src/components/Audits';
import ChatNightMode from 'src/components/ChatNightMode';
import { CasinoMobileVersion } from 'src/main/AdminPage/CasinoMobileVersion/CasinoMobileVersion';
import { useAppStateContext } from 'src/AppState/AppState';
import { useCommon } from 'src/AppState/Common';
import { ConfigState } from 'src/AppState/ConfigState/ConfigState';
import { Permission } from 'src/AppState/PermissionGrants/PermissionGrants.types';
import { AppUpdate } from 'src/main/AdminPage/AppUpdate/AppUpdate';
import { ComplianceAudits } from 'src/components/ComplianceAudits/ComplianceAudits';
import { AdminMenuItems } from 'src/layouts/AdminPage/AdminMenuItems';
import { SystemSettingsForm } from 'src/components/SystemSettingsForm/SystemSettingsForm';
import { LayoutWrapper, MainContainer, MainContent } from 'src/domains/layouts/shared/layout/Layout.style';
import { EventsTrigger } from 'src/components/EventsTrigger/EventsTrigger';
import { PepXmlRouterWrapper } from 'src/components/FraudAndCompliance/PEPTab/PEP/PepXml/PepXml';
import { ConfigurationManager } from 'src/domains/layouts/webview/ConfigurationManager/configurationManager';
import { AuditIdMission } from 'src/components/AuditIdMission/AuditIdMission';
import { ComplianceConfiguration } from 'src/components/ComplianceConfiguration/ComplianceConfiguration';

// interface PropsTypes {
//     rcClasses: {
//         'not-permitted': boolean;
//     };
// }

export const AdminPageContent = observer(() => {
    const common = useCommon();
    const {
        isProdMode,
        permissionGrantsState,
        reduxBackofficeUserState: { isSuperUser },
        routerBackoffice,
        sdkStaff,
    } = useAppStateContext();
    const {
        config: { tableauDashboards, configurationManagerUI, idMission },
    } = ConfigState.get(common);
    const hasComplianceConfigPermission = permissionGrantsState.has(Permission.complianceComplianceConfig);

    const customerParams = routerBackoffice.getParametersString('global', 'tab') ?? 'users';

    useEffect(() => {
        if (customerParams === 'license-config' && hasComplianceConfigPermission && idMission) {
            routerBackoffice.redirectToComplianceConfigurationLicenseConfig();
        }
    }, [customerParams, hasComplianceConfigPermission, idMission, routerBackoffice]);

    const shouldDisplayConfigurationManagerUI =
        customerParams === 'configuration-manager' && isSuperUser && configurationManagerUI;

    return (
        <LayoutWrapper>
            <Header />

            <MainContainer>
                <AdminMenuItems />
                <MainContent>
                    {customerParams === 'users' && (
                        <AdminUsers
                            key='users'
                            label='Users'
                            sdkStaff={sdkStaff}
                            isSuperUser={isSuperUser}
                            isProdMode={isProdMode}
                            tableauDashboards={tableauDashboards}
                        />
                    )}
                    {customerParams === 'role-and-permissions' && <AdminRolesAndPermissions />}
                    {customerParams === 'country-defaults' && <AdminCountryDefaultsNew />}
                    {customerParams === 'change-password' && <AccountStaffChangePasswordForm />}
                    {customerParams === 'system-settings' && <SystemSettingsForm />}
                    {customerParams === 'pricing-ladders' && <Ladders />}
                    {/*{customerParams === 'related-contingency' && (*/}
                    {/*    <RelatedContingency className={classNames(rcClasses)} />*/}
                    {/*)}*/}
                    {customerParams === 'chat-night-mode' && <ChatNightMode />}
                    {customerParams === 'casino-mobile-version' && isSuperUser && <CasinoMobileVersion />}
                    {customerParams === 'app-update' && <AppUpdate />}
                    {customerParams === 'compliance-configuration' && hasComplianceConfigPermission && (
                        <ComplianceConfiguration />
                    )}
                    {shouldDisplayConfigurationManagerUI && <ConfigurationManager />}
                </MainContent>
            </MainContainer>

            <CustomersBar />
            <EventsTrigger />
            <Audits />
            <ComplianceAudits />
            <AuditIdMission />
            <PepXmlRouterWrapper />
        </LayoutWrapper>
    );
});
